<template>
<v-card @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title primary-title>
        <div class="hotel-card-title pa-2">
            {{ $t('hotel.card.billing.title') }}
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="procent" @click="status_dialog = true">
                    <span :class="color + '--text'">
                        {{ procent_status }}%
                    </span>
                    <v-icon size="19" :color="color">info</v-icon>
                </div>
            </template>
            <div class="">
                <div class=" important white--text">
                    Rata completare <span class="text-lowercase"> {{ $t('hotel.card.media.title') }} </span>
                </div>
                <div class="" v-if="!billing.name">
                    Unitatea dvs nu are date de facturare inregistrate in aceasta paltfomra
                </div>
                <div class="" v-if="!billing.banks.length">
                    Un cont bancar ar ajuta la plata facturilor
                </div>
                <div class="" v-if="procent_status == 100">
                    Felicitari unitatea dvs are informatii complete si sanse mai mari la noi rezervari
                </div>
            </div>
        </v-tooltip>
        <!-- <v-icon class="px-2 mr-3 icon-edit" color="#5A8DEE" v-show="hover" @click="emitOpenDialog()">edit</v-icon> -->

    </v-card-title>
    <v-card-text>
        <div class="pa-2" v-if="billing.fiscal_code">
            <div class="font-weight-medium">{{ $t('hotel.billing.profile') }}:
                <span class="font-weight-bold">{{ billing.name }}</span>
            </div>
            <div class="">{{ billing.fiscal_code }}</div>
            <div class="">{{ billing.registry_number }}</div>
            <div class="">
                <span v-if="billing.address.street">, {{ billing.address.street }}</span>
                <span v-if="billing.address.number">, {{ billing.address.number }}</span>
                <span v-if="billing.address.building">, {{ billing.address.building }}</span>
            </div>
            <div class="">
                {{ billing.address.city }}
                <span v-if="billing.address.postal_code">, {{ billing.address.postal_code }}</span>
            </div>
            <template v-if="billing.banks.length">
                <div class=" font-weight-medium">
                    {{ $t('hotel.billing.bank') }}:
                </div>
                <div class="" v-for="(bank,index) in billing.banks" :key="index">
                    <div class>{{ bank.name }}</div>
                    <div class>{{ bank.account }} {{ bank.currency }}</div>
                </div>
            </template>
        </div>
        <div class="" v-else>
            {{ $t('hotel.card.billing.no_data') }}
        </div>

        <!--info dialog-->
        <v-dialog v-model="status_dialog" max-width="720">
            <v-card>
                <v-card-title class="hotel-card-title" primary-title>
                    Info
                </v-card-title>
                <v-card-text class="info-text">
                    <div class="" v-if="!billing.name">
                        Unitatea dvs nu are date de facturare inregistrate in aceasta paltfomra
                    </div>
                    <div class="" v-if="!billing.banks.length">
                        Un cont bancar ar ajuta la plata facturilor
                    </div>
                    <div class="" v-if="procent_status == 100">
                        Felicitari unitatea dvs are informatii complete si sanse mai mari la noi rezervari
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="status_dialog=false">
                        {{ $t('button.exit') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--./info dialog -->

    </v-card-text>
</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        item: Object,
    },
    name: `item-hotel`,
    data() {
        return {
            status_dialog: false,
            color: 'grey',
            hover: false,
            org_id: null,
            billing: {
                name: null,
                type: null,
                fiscal_code: null,
                registry_number: null,
                banks: [{
                    name: null,
                    account: null,
                    currency: null,
                }],
                contact: {
                    name: null,
                    email: null,
                    phone: null,
                    position: null,
                },
                address: {
                    country: null,
                    state: null,
                    city: null,
                    street: null,
                    number: null,
                    building: null,
                    postal_code: null,
                }
            },
        };
    },

    watch: {
        item: {
            handler() {
                this.getBillingDetail(this.item.org_id);
            }
        },
    },

    created() {
        this.getBillingDetail(this.item.org_id);
    },

    computed: {
        procent_status() {
            let procent = 0;
            if(this.billing.name) {
                procent += 70;
            }
            if(this.billing.banks.length) {
                procent += 30;
            }

            this.setColor(procent);
            return procent;
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getBillingDetail(value) {

            if(!value) {
                return
            }
            // construct params object
            let params = {
                params: {
                    owner_ids: [value]
                }
            };
            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/billings";

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.data[0]) {
                        this.billing = response.data.data[0];
                    }
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {});
        },

        setColor(procent) {
            if(procent < 51) {
                this.color = 'red'
            }
            if(50 < procent && procent < 81) {
                this.color = 'orange'
            }
            if(procent > 80) {
                this.color = 'green'
            }
        },

        emitOpenDialog() {
            this.$emit('openDialog');
        }
    },
};
</script>
